import { useEffect } from 'react'
import { BRAND_NAME } from '../config/brand'

/** Marque affichée dans l'onglet (nom propre : non traduit). */
export const APP_TITLE = BRAND_NAME

/**
 * Titre d'onglet : « <Page> · iCall CRM », ou « iCall CRM » seul sans libellé.
 * Le libellé est DÉJÀ traduit par l'appelant (clés i18n `pages.*`).
 * Au démontage, le titre revient à la marque seule.
 */
export function useDocumentTitle(label?: string | null): void {
  useEffect(() => {
    const trimmed = label?.trim()
    document.title = trimmed ? `${trimmed} · ${APP_TITLE}` : APP_TITLE
    return () => {
      document.title = APP_TITLE
    }
  }, [label])
}
